import React from "react";
import { IconLibrary } from "./types";

export const KameleonIconContext = React.createContext(
  IconLibrary.MaterialSymbols
);
